/* eslint-disable @typescript-eslint/no-misused-promises */
import { Typography, Button, useMediaQuery } from '@mui/material';
import { getCliengoService } from '@cliengo/mfe-utils/services';

import { Flex } from '../utils';

import { useTranslate } from '@/hooks';

interface AffiliateButtonProps {
  companyName: string;
}

export const AffiliateButton = ({ companyName }: AffiliateButtonProps) => {
  const isSmall = useMediaQuery('(max-width: 980px)');
  const { t } = useTranslate('profileButtom');

  const logoutLikeAffiliate = async () => {
    const cliengoService = getCliengoService();

    try {
      await cliengoService.http.get('/account/affiliate/logout');
      window.location.reload();
    } catch (error) {
      console.error('Error in Affiliate button:', error);
    }
  };

  return (
    <Flex alignItems="center" gap=".5rem">
      {!isSmall && (
        <Typography>
          {t('loggedIn')}{' '}
          <strong style={{ color: '#1ABC9C' }}>{companyName}</strong>
        </Typography>
      )}
      <Button variant="contained" color="primary" onClick={logoutLikeAffiliate}>
        <strong>{t('returnAffiliate')}</strong>
      </Button>
    </Flex>
  );
};
